
import { z } from "zod";

export const UploadCompletedWorkPhotosAttemptTypeValues = ["UPLOAD", "REQUEST"] as const;
export const UploadCompletedWorkPhotosAttemptTypeSchema = /* @__PURE__ */ z.enum(UploadCompletedWorkPhotosAttemptTypeValues);
export const UploadCompletedWorkPhotosAttemptType: (typeof UploadCompletedWorkPhotosAttemptTypeSchema)["enum"] = { "UPLOAD": "UPLOAD", "REQUEST": "REQUEST" };
export type UploadCompletedWorkPhotosAttemptType = (typeof UploadCompletedWorkPhotosAttemptTypeValues)[number];
